import React, { useState, useRef, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import Input from 'components/Input';
import InputEmail from 'components/InputEmail';
import TagManagerService from 'services/TagManager';
import PropTypes from 'prop-types';
import {modalRegisterTxt} from 'config/translate/variables';
import { Link } from 'react-router-dom'
import style from './style.scss';//NOSONAR

let isvalid = '';
let firstNameValid = false;
let lastNameValid = false;
let emailValid = false;


const Register = ({closeRegister, dataModal}) => {
    const firstName = useRef();
    const lastName = useRef();
    const email = useRef();
    const checkbox = useRef(null);
    const checkboxTer = useRef(null);

    const [formIsValid, setFormIsValid] = useState(false);
    const [emailValue, setEmailValue] = useState('');
    const [firstNameValue, setFirstNameValue] = useState('');
    const [lastNameValue, setLastValue] = useState('');
    const [offersValue, setOffersValue] = useState(false);
    const [termsValue, setTermsValue] = useState(false);

    useEffect(() => {
        registerInit(dataModal);

    }, [dataModal]);

    const registerInit = (payload) => {
        const fName = payload ? payload.firstName : '';
        const lName = payload ? payload.lastName : '';
        const userEmail = payload ? payload.email : '';
        const offers = payload ? payload.isNewsletterOptIn : '';
        const terms = payload ? payload.termsValue : '';

        if(fName) {
            setFirstNameValue(fName);
        }

        if(lName) {
            setLastValue(lName);
        }

        if(userEmail) {
            setEmailValue(userEmail);
        }

        if(offers) {
            setOffersValue(offers);
        }

        if(terms) {
            setTermsValue(terms);
            setFormIsValid(true);
        }
    }

    useEffect(()=>{
        setTimeout(()=> validateForm() , 100);
    },[emailValue, termsValue])

    const _getNameValid = (isValid) => {
        firstNameValid = isValid;
    }

    const _getLastNameValid = (isValid) => {
        lastNameValid = isValid;
    }

    const _getValidMail = (isValid) => {
        emailValid = isValid;
    }

    const validateForm = () => {
        if ((firstName && firstName.current) && (lastName && lastName.current) && (email && email.current)) {
            isvalid = firstNameValid && lastNameValid && emailValid && termsValue;
            setFormIsValid(isvalid);

        } else {
            setFormIsValid(false);
        }
    }

    const handleCheckOffers = () => {
        if (checkbox.current.checked){
            setOffersValue(true)
        }else{
            setOffersValue(false)

        }
    }

    const handleCheckTerms = () => {

        if (checkboxTer.current.checked){
            setTermsValue(true);
        }else{
            setTermsValue(false);
        }
    }

    const validateInput = (value) => {
        return typeof(value) === 'string' && value.trim().length >= 3;
    }

    const handleSubmitForm = (event) => {
        if (event) {
            event.preventDefault();
        }

        if (!(formIsValid && firstName && lastName && email)) return false;

        const fName = firstName.current.value;
        const lName = lastName.current.value;
        const mail = email.current.value;
        const offers = checkbox.current.checked;
        const terms = checkboxTer.current.checked;
        setOffersValue(offers);
        setTermsValue(terms);
        closeRegister();

        PubSub.dispatch('forgot_password_open', {
            email: mail,
            register: {
                email: mail,
                firstName: fName,
                lastName: lName,
                isNewsletterOptIn: offersValue,
                terms : termsValue
            },
            goToRegister: true
        });

        TagManagerService.registerAccount('Registrar', 'Crea tu cuenta', window.location.href);
    }

    const goLogin = () => {
        closeRegister();
        PubSub.dispatch('login_open');
    }

    return (
        <form className='new-modal-container login-cont active' onSubmit={handleSubmitForm}>
            <div className="new-modal-scroll register-cont active">
                <span className="new-modal-title">{modalRegisterTxt.title}</span>
                <div className="form-container" >
                    <Input
                        ref={firstName}
                        key={'name'}
                        className={'register-form-input'}
                        name={'name'}
                        label={'Nombre'}
                        value={firstNameValue}
                        type={'text'}
                        onChange={validateInput}
                        validate={validateInput}
                        helpText=""
                        size=""
                        message={{
                            "error": "Campo obligatorio"
                        }}
                        validateForm={validateForm}
                        callbackValidate={_getNameValid}
                    />
                    <Input
                        ref={lastName}
                        key={'lastname'}
                        className={'register-form-input'}
                        name={'lastname'}
                        label={'Apellido'}
                        value={lastNameValue}
                        type={'text'}
                        helpText=""
                        size=""
                        onChange={validateInput}
                        validate={validateInput}
                        message={{
                            "error": "Campo obligatorio"
                        }}
                        validateForm={validateForm}
                        callbackValidate={_getLastNameValid}
                    />
                    <InputEmail
                        ref={email}
                        key="Email"
                        className={'register-form-input'}
                        name="Email"
                        label="Mail"
                        value={emailValue}
                        type="email"
                        helpText=""
                        size=""
                        message={{ error: "Ingresa una dirección de mail válida" }}
                        validateForm={validateForm}
                        callbackValidate={_getValidMail}
                    />
                    <div className="register-container-form-label">
                        <label className="register-form-label">
                            <input type="checkbox" name='offers' ref={checkbox} onChange={handleCheckOffers} checked={offersValue}/>
                            <span className="register-message-terms">Acepto recibir información de ofertas y promociones de Jumbo.cl</span>
                        </label>
                    </div>
                    <div className="register-container-form-label">
                        <label className="register-form-label">
                            <input type="checkbox" name='Terms' ref={checkboxTer} onChange={handleCheckTerms} checked={termsValue}/>
                            <span className="register-message-terms">Al registrarte aceptas los <Link target={"_blank"} to="/institucional/terminos-condiciones" className="register-link">Términos y condiciones</Link></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="modal-actions">
                <div className="register-cont-btn">
                    <button type="button" className="secundary-btn" onClick={goLogin}>
                        <span className="register-btn-back">{modalRegisterTxt.btnCancel}</span>
                    </button>
                    <button type="submit" className={formIsValid  ? 'primary-btn' : 'disabled-btn'}>
                        <span className="btn-submit-next">{modalRegisterTxt.btnSubmit}</span>
                    </button>
                </div>
            </div>
        </form>
    );
}

Register.propTypes = {
    closeRegister: PropTypes.func,
    dataModal: PropTypes.object
};


export default Register;
